import React, { useEffect, useState } from "react";
import "./live.css";
import JWPlayer from "@jwplayer/jwplayer-react";
import Ticker from "../Ticker/ticker";
import { getFullPageDetails, getTicker } from "../api/core";
import { Helmet } from "react-helmet";
import Global from "../../global";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LiveFull from "../boxedPlayer/livefull";

const Live = (props) => {
  const { t } = useTranslation(["translation"]);
  const [live, setLive] = useState("");
  const [tickStatus, SetTickStatus] = useState("");
  const [tick, setTick] = useState([]);
  const [liveTitle, setLiveTitle] = useState("");
  const history = useHistory();
  useEffect(() => {
    const LiveDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getFullPageDetails(app, id).then(
        (result) => {
          setLive(result.data.livePage);
          getTickerDetail(app, id);
          setLiveTitle(result.data.displayName);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };
    const getTickerDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getTicker(app, id).then(
        (result) => {
          setTick(result.data);
          SetTickStatus(result.status);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };

    LiveDetail(props.match.params.AppId, props.match.params.Id);
  }, [props.match.params.Id, props.match.params.AppId]);

  const goBack = () => {
    // watchHistory(second,props.match.params.Id);
    history.goBack();
  };

  return (
    <div className="watchClass">
      <Helmet>
        <title>{liveTitle}</title>
      </Helmet>
      {Global.LIVE === "JWPlayer" ? (
        <JWPlayer
          library={"https://cdn.jwplayer.com/libraries/" + Global.FSP + ".js"}
          file={live}
        />
      ) : (
        <LiveFull url={live} {...props}></LiveFull>
      )}

      <div style={{ transition: "opacity 0.25s ease-in-out 0s", opacity: 1 }}>
        <div className="back_wrapper">
          <div className="back_wrap">
            <div
              className="_backbutton _backCrypto"
              aria-label="Back"
              role="button"
              tabIndex={0}
              onClick={goBack}
            >
              <svg
                className="_backSvg"
                viewBox="0 0 24 24"
                focusable="false"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                </g>
              </svg>
            </div>
            <div>
              <h2 className="_backHeading">{liveTitle}</h2>
              <div className="_backSub">
                <div className="_backSubed">{t("label_Live")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {tickStatus.toString() === "200" && tick != null ? (
        <Ticker id={"ticker" + 20} tickData={tick}></Ticker>
      ) : (
        ""
      )}
    </div>
  );
};

export default Live;
